import { transformFormItems } from '../../static/js/panguFormUtils'
import compileVariableUtil from '../../static/js/compileVariableUtil'
import createFormConverterUtil from '../../static/js/createFormConverterUtil'
import objectUtil from '../../static/js/objectUtil'
class FormStore {
  constructor($this, initialState = {}, initialMutations, initialActions) {
    this.$this = $this

    //状态数据
    this.states = {
      responseData: { errors: null },
      oldFormData: null, // 修改后的 formData 旧值
      formData: null,
      formProps: null,
      definitionList: [],
      extendData: {
        rows: [],
        tableData: [], // 需求#5841，新增的
        length: 0,
      },
      //用于存储一些子组件中的状态，一般用于在切换tab时需要保留状态
      childrenPrivate: {},
      //页面切换时不需缓存的数据
      provisional: {},
    }

    //修改states的方法
    this.mutations = {
      setForm(states, formArr, getFormData) {
        const [formRes, formPropsRes, oldFormRes] = formArr
        const compileData = compileVariableUtil.getCompileVariable(formRes, this.$this)
        const { formData, resItems } = transformFormItems(
          formPropsRes.items,
          formRes,
          getFormData,
          compileData
        )

        states.oldFormData = oldFormRes // #9626, 存储修改后的旧值
        states.formData = formData
        states.definitionList = resItems
        states.formProps = createFormConverterUtil.getCreateFormProps(formPropsRes.form, null)
      },
      setFormData(states, val) {
        states.formData = val
      },
      setResErrors(states, val) {
        states.responseData.errors = val
      },
      setChildrenPrivate(states, key, val) {
        objectUtil.setValueByPath(states.childrenPrivate, key, val)
      },
    }
    //操作方法
    this.actions = {
      //获取表单值，
    }

    //初始赋值自定义state
    for (let prop in initialState) {
      if (
        Object.prototype.hasOwnProperty.call(initialState, prop) &&
        Object.prototype.hasOwnProperty.call(this.states, prop)
      ) {
        this.states[prop] = initialState[prop]
      }
    }

    //初始赋值自定义mutations
    for (let prop in initialMutations) {
      if (Object.prototype.hasOwnProperty.call(initialMutations, prop)) {
        this.mutations[prop] = initialMutations[prop]
      }
    }

    //初始赋值自定义actions
    for (let prop in initialActions) {
      if (Object.prototype.hasOwnProperty.call(initialActions, prop)) {
        this.actions[prop] = initialActions[prop]
      }
    }
  }

  commit(name, ...args) {
    const mutations = this.mutations
    if (mutations[name]) {
      mutations[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }

  dispatch(name, ...args) {
    const actions = this.actions
    if (actions[name]) {
      return actions[name].apply(this, [this].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }
}

export default FormStore
